import { useSticker } from '../context/StickerContext';
import { calculatePrice } from '../utils/pricing';

export function usePrice() {
  const { size, quantity } = useSticker();
  
  // Ensure quantity is within valid range
  const validQuantity = Math.min(Math.max(50, quantity), 10000);
  const totalPrice = calculatePrice(size.width, size.height, validQuantity);
  const pricePerSticker = validQuantity > 0 ? totalPrice / validQuantity : 0;
  
  return {
    totalPrice,
    pricePerSticker,
    validQuantity,
  };
}
